export default __webpack_public_path__ + "static/media/bh2.7fbf6dbf.webp";